import { Component, ViewEncapsulation, Input, Renderer2, ChangeDetectorRef, EventEmitter, Output, NgZone } from '@angular/core';
import { DispatchesService } from '../../../shared/services/dispatches.service';
import { GlobalsService } from '../../../shared/services/globals.service';
import { Subscription, fromEvent, Subject } from 'rxjs';
import { DataStateChangeEvent, RowClassArgs } from '@progress/kendo-angular-grid';
import { v_DispatchPartsRequestedBus } from '../../../shared/models/v_DispatchPartsRequestedBus';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DispatchPartsRequestedBus } from '@app/cp/shared/models/DispatchPartsRequestedBus';
import { DispatchPartsRequestMessageInfo } from '@app/cp/shared/models/DispatchPartsRequestMessageInfo';
import { MessageType } from '@app/cp/shared/enums/MessageType';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { MSFilterClass } from '@app/cp/shared/classes/filters/MSFilterClass';
import { take, tap } from 'rxjs/operators';
import * as _ from 'lodash';
import { GItem } from '../../../shared/models/GItem';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';

@UseFeatureFlagSet()
@Component({
    selector: 'dispatch-parts-requested',
    templateUrl: './dispatch-parts-requested.component.html',
    styleUrls: ['./dispatch-parts-requested.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DispatchPartsRequestedComponent extends BaseGridEditLineComponent<v_DispatchPartsRequestedBus, null, DispatchesService>  {
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    inventoryLocationFC: MSFilterClass = new MSFilterClass("inventoryLocationId");
    @Input() canEditWrongParts: boolean = false;
    @Input() canAddPartsToOrder: boolean = true;
    @Output() dropEvent: EventEmitter<any> = new EventEmitter<any>();
    private destroy$ = new Subject();
    private currentSubscription: Subscription;
    constructor(globals: GlobalsService, renderer: Renderer2, private zone: NgZone, cd: ChangeDetectorRef,svc_data: DispatchesService, svc_inv: InventoryService, featureFlagService: FeatureFlagService) {
    super(globals, renderer, cd, featureFlagService);
    this.svc_data = svc_data;

        this.className = "v_DispatchPartsRequestedBus";
        this.appCode = "DispatchPartsRequested";
        this.appName = "Dispatch Parts Requested";
        this.inventorySvcField = "number";
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'dispatchPartsRequestId': new UntypedFormControl(),
            'dispatchId': new UntypedFormControl(),
            'addToOrder': new UntypedFormControl(),
            'inventoryId': new UntypedFormControl(),
            'number': new UntypedFormControl(),
            'inventoryDesc': new UntypedFormControl(),
            'fullDescription': new UntypedFormControl(),
            'fromInventoryLocationId': new UntypedFormControl(),
            'inventoryLocationId': new UntypedFormControl(),
            'inventoryLocationName': new UntypedFormControl(),
            'qtyInStock': new UntypedFormControl(),
            'quantity': new UntypedFormControl(),
            'usedPartQuantity': new UntypedFormControl(),
            'lastSupplier': new UntypedFormControl(),
            'addedDate': new UntypedFormControl(),
            'isXfered': new UntypedFormControl(),
            'viewedInMobile': new UntypedFormControl(),
            'isWrongPart': new UntypedFormControl(),
            'needsReplacement': new UntypedFormControl(),
            'personName': new UntypedFormControl(),
            'personId': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'warehouse': new UntypedFormControl(),
            'row': new UntypedFormControl(),
            'bay': new UntypedFormControl(),
            'bin': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),
            'locationQuantity': new UntypedFormControl(),
            'allQuantity': new UntypedFormControl(),

        });

    }
    setForm() {
        this.editForm.patchValue({
            dispatchPartsRequestId: this.selectedData.dispatchPartsRequestId,
            dispatchId: this.selectedData.dispatchId,
            addToOrder: this.selectedData.addToOrder,
            inventoryId: this.selectedData.inventoryId,
            number: this.selectedData.number,
            inventoryDesc: this.selectedData.inventoryDesc,
            fullDescription: this.selectedData.fullDescription,
            fromInventoryLocationId: this.selectedData.fromInventoryLocationId,
            inventoryLocationId: this.selectedData.inventoryLocationId,
            inventoryLocationName: this.selectedData.inventoryLocationName,
            qtyInStock: this.selectedData.qtyInStock,
            quantity: this.selectedData.quantity,
            usedPartQuantity: this.selectedData.usedPartQuantity,
            lastSupplier: this.selectedData.lastSupplier,
            addedDate: this.selectedData.addedDate,
            viewedInMobile: this.selectedData.viewedInMobile,
            isXfered: this.selectedData.isXfered,
            isWrongPart: this.selectedData.isWrongPart,
            needsReplacement: this.selectedData.needsReplacement,
            personName: this.selectedData.personName,
            personId: this.selectedData.personId,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId,
            warehouse: this.selectedData.warehouse,
            allQuantity: this.selectedData.allQuantity,
            locationQuantity: this.selectedData.locationQuantity,
            bin: this.selectedData.bin,
            bay: this.selectedData.bay,
            row: this.selectedData.row
        });
    }
    canCrOrder: boolean = false;
    createOrder() {
        if (this.editForm) {
            this.saveCurrent();
        }
        let addToOrder: DispatchPartsRequestedBus[] = this.getAddToOrder();
        //if (!CommonFunctions.hasGuidValue(this.parentId)) {
        //        this.setAfterSaveMessage({ messageType: MessageType.assignNewTech, value: personToAssignId, values: personToAssignId, messageSubject: null, message: null, dqoiIndex: null, searchTarget: SearchTarget.any, refreshTarget: null });
        //        this.save();
        //}
        //else {

            this.sendParentMessage(MessageType.createOrderFromParts, null, null, addToOrder, this.parentId)
        //}
    }
    customCheckBoxChanged(e: any, dataItem, rowIndex, column, columnIndex) {
        if (column.field === "isWrongPart") {
            this.editForm.patchValue({
                isWrongPart: e.target.checked
            });

        }
        if (column.field === "isXfered") {
            this.editForm.patchValue({
                isXfered: e.target.checked
            });
        }
        if (column.field === "viewedInMobile") {
            this.editForm.patchValue({
                viewedInMobile: e.target.checked
            });
        }
        if (column.field === "needsReplacement") {
            this.editForm.patchValue({
                needsReplacement: e.target.checked
            });

        }
        if (column.field === "addToOrder" && this.canAddPartsToOrder) {
            this.editForm.patchValue({
                addToOrder: e.target.checked
            });
            this.canCrOrder = this.hasAddToOrder();
            this.cd.detectChanges();
        }
    }
    addToOrderChanged(e: any, data: v_DispatchPartsRequestedBus) {
       // data.addToOrder = e.target.checked;
//        this.selectedData.addToOrder = e.target.checked;
        if (e.target.checked) {
            this.canCrOrder = true;
        }
        else {
            this.canCrOrder = this.hasAddToOrder();
        }
    }
    protected hasAddToOrder(): boolean {
        let retVal = false;
        if (this.hasGridData) {
            let temp = this.gridData.filter(s => s.addToOrder === true);
            if (CommonFunctions.hasValue(temp)) {
                retVal = true;
            }
        }
        return retVal;
    }
    public getAddToOrder(): any {
        let addToOrder: DispatchPartsRequestedBus[] = [];
        if (this.hasGridData) {
            var arrCrParts: v_DispatchPartsRequestedBus[] = [];
            for (let i = 0; i < this.gridData.length; i++) {
                if (this.gridData[i].addToOrder) {
                    let dataObj: DispatchPartsRequestedBus = this.getChangedObject(this.gridData[i]);
                    addToOrder.push(dataObj);
                    arrCrParts.push(this.gridData[i]);
//                    this.removeLocal(this.gridData[i]);
                }
            }
            if (CommonFunctions.hasArrayElementValue(arrCrParts)) {
                for (let i = 0; i < arrCrParts.length; i++) {
                    this.removeLocal(arrCrParts[i]);
                }
            }
        }
        return addToOrder;
    }

    get canEditWrongPart(): boolean {
        let can: boolean = false;

        if (this.canEdit && this.selectedData) {
            if (this.canEditWrongParts) {
                can = true;
            }
        }

        return can;
    }
    canEditRow(dataItem: v_DispatchPartsRequestedBus) {
        return super.canEditRow(dataItem) && CommonFunctions.hasValue(dataItem) && (!dataItem.onConstDraw || this.rights.FinancialLockOverride);
    }

    setQuantityInStock(newQtyInStock: number) {
        this.editForm.patchValue({
            qtyInStock: newQtyInStock
        });

    }

    setQuantityInStockDetail(item: any) {
        if (!item) {
            item = { quantity: "", aisle: "", bin :""}
        }
        this.editForm.patchValue({
          //  qtyInStock: item.quantity,
            row: item.aisle,
            bay: item.section,
            bin: item.bin
        });

    }
    afterSetInventorySearchData() {
        if (CommonFunctions.hasValue(this.selectedData) && CommonFunctions.hasGuidValue(this.selectedData.fromInventoryLocationId)) {
            this.invLocCBOChanged(this.selectedData.fromInventoryLocationId);
        }

    }
    invLocCBOChanged(id: any) {
        if (id.value) { id = id.value; }
        var warehouse = this.warehouseName(id);
        this.editForm.patchValue({
            warehouse: warehouse
        });

        if (this.compFeatureFlagSet.featureFlagSet['add-row-bay-shelf-columns-to-parts-requested-screen']) {
              this.svc_inv.getLocationQuantityDetail(this.selectedData.inventoryId, id).subscribe((data: number) => {
                this.setQuantityInStockDetail(data);

            });
}
        else {
         this.svc_inv.getLocationQuantity(this.selectedData.inventoryId, id).subscribe((data: number) => {
                this.setQuantityInStock(data);

            });
        }

    }
    getChangedObject(dataObj: v_DispatchPartsRequestedBus) {
        let busObj: DispatchPartsRequestedBus = new DispatchPartsRequestedBus(dataObj);
        busObj.setBeforeSave();
        return busObj;
    }
    protected save(dataObj: v_DispatchPartsRequestedBus) {

        let busObj: DispatchPartsRequestedBus = this.getChangedObject(dataObj);

        this.svc_data.savePartsRequest(busObj).subscribe((data: DispatchPartsRequestMessageInfo) => {
            if (!data.saveError) {
                let newDataObj: v_DispatchPartsRequestedBus = new v_DispatchPartsRequestedBus(data.dispatchPartsRequestView);
                this.saveSuccess(newDataObj);
            }
            else {
                this.saveError(dataObj, data.message);
            }
        })
    }
    deleteIndividual(data: v_DispatchPartsRequestedBus) {
        if (data.hasId) {
            this.svc_data.deletePartsRequest(data.dispatchPartsRequestId).subscribe((dataObj: DispatchPartsRequestMessageInfo) => {
                if (!dataObj.saveError) {
                    this.deleteSuccess(data);
                    this.removeLocal(data);
                }
                else {
                    this.deleteError(data, dataObj.message);

                }
            });
        }
        else {
            this.closeEditor();
        }
    }
    getDragReady() {

        if (this.currentSubscription) {
            var subs = this.currentSubscription;
            if (this.destroy$) {
                this.destroy$.next('TODO: BILL LOOK AT THIS');
                this.destroy$.complete();
            }
            this.destroy$ = new Subject();
            this.currentSubscription.unsubscribe();
        }
        if (this.canDrag) {
            this.zone.onStable.pipe(take(1))
                .subscribe(() => this.currentSubscription = this.handleDragAndDrop());
        }
    }
    personCBOChanged(e: GItem, editForm) {

        this.editForm.patchValue({
            personId: e.value,
            personName: e.description
        }
        )

    }
    processGridData() {
        if (this.hasGridData) {
            for (let i = 0; i < this.gridData.length; i++) {
                if (!this.gridData[i].personName) {
                    this.gridData[i].personName = this.personName(this.gridData[i].personId);
                }
                if (!this.gridData[i].warehouse) {
                    this.gridData[i].warehouse = this.warehouseName(this.gridData[i].fromInventoryLocationId);

                }
            }
        }
        this.getDragReady();
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        if (state && state.group) {
            state.group.map(group => group.aggregates = this.aggregates);
        }
        this.state = state;
        this.getDragReady();
    }
    private handleDragAndDrop(): Subscription {
        const sub = new Subscription(() => { });
        let draggedItemIndex;
        const tableRows = Array.from(document.querySelectorAll('div.partsRequestedGridDiv > .k-grid tr'));
        const _this = this;
        tableRows.forEach(item => {
            this.renderer.setAttribute(item, 'draggable', 'true');
            const dragStart = fromEvent<DragEvent>(item, 'dragstart');
            const dragOver = fromEvent(item, 'dragover');
            const dragEnd = fromEvent(item, 'dragend');
            var dropItemIndex;
            var dataItem;
            sub.add(dragStart.pipe(
                tap(({ dataTransfer }) => {
                    try {

                        //const dragImgEl = document.createElement('span');
                        //dragImgEl.setAttribute('style', 'position: absolute; display: block; top: 0; left: 0; width: 0; height: 0;');
                        //document.body.appendChild(dragImgEl);
                        //dataTransfer.setDragImage(dragImgEl, 0, 0);
                    } catch (err) {
                        // IE doesn't support setDragImage
                    }
                    try {
                        // Firefox won't drag without setting data
                        dataTransfer.setData('application/json', "");
                    } catch (err) {
                        // IE doesn't support MIME types in setData
                    }
                })
            ).subscribe(({ target }) => {
                const row: HTMLTableRowElement = <HTMLTableRowElement>target;
                draggedItemIndex = row.rowIndex;
                var data = _.cloneDeep(this.grid.data);
                dataItem = data.data[draggedItemIndex];
                //   dataItem.dragging = true;
            }));

            //sub.add(dragOver.subscribe((e: any) => {
            //    e.preventDefault();
            //    const dataItem = this.gridData.data.splice(draggedItemIndex, 1)[0];
            //    const dropIndex = closest(e.target, tableRow).rowIndex;
            //    const dropItem = this.gridData.data[dropIndex];

            //    draggedItemIndex = dropIndex;
            //    this.zone.run(() =>
            //       // this.gridData.data.splice(dropIndex, 0, dataItem)
            //    );
            //}));

            sub.add(dragEnd.subscribe((e: any) => {
                e.preventDefault();
                var event = _.cloneDeep(dataItem);
                event.detailType = 2;
                event.dropid = event.dispatchPartsRequestId

                this.dropEvent.emit(event);
                // const dataItem = this.gridData.data[draggedItemIndex];
                //   dataItem.dragging = false;
            }));
        });

        return sub;
    }
    rowCallback(context: RowClassArgs) {
        if (context.dataItem)
            return {
                onConstDraw: context.dataItem.onConstDraw,
                inFinance: !context.dataItem.onConstDraw && context.dataItem.inFinance
            };
        return {};
    }

    test() {
        console.log("disp-parts-req->test: ", this.canAddPartsToOrder, this);
    }
}
